import { default as NewPassword } from './new-password';

export default NewPassword;



// WEBPACK FOOTER //
// ./src/components/pages/new-password/index.js